import { getApp, getApps, initializeApp } from 'firebase/app';

import { firebaseWebConfig } from './config';

export function getFirebaseApp() {
  if (getApps().length === 0) {
    return initializeApp(firebaseWebConfig);
  }
  return getApp();
}
